import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'documents.list.component.html',
  providers: []
})

export class DocumentsListComponent {

  model: any = {};

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/documents/list/documents.list.component.ts